import { render, staticRenderFns } from "./login-via-url.vue?vue&type=template&id=f2b3c9ce&"
import script from "./login-via-url.vue?vue&type=script&lang=js&"
export * from "./login-via-url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports